import React, {Component} from 'react'
import Swal from 'sweetalert2';
import axios from 'axios';

class Subscribe extends Component{
    state = {
        email_: '',
      }
    
      handleSubscribe(event) {        
        event.preventDefault();
        
        let formData = new FormData();
        
        formData.append('email', this.state.email_);
         
        
        if(this.state.email_ === ''){
            Swal.fire({
                title: 'Empty email field',
                text: 'Please enter your email address',
                icon: 'error',
                confirmButtonText: 'OK'
              });
        } else {

        axios({
            method: 'post',
            url: 'https://codeflarelimited.com/api/subscribe.php',
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(function (response) {
           if(response.status === 200){
            Swal.fire({
                title: 'Success!',
                text: 'Message sent successfully',
                icon: 'success',
                confirmButtonText: 'OK'
              })
              .then(function() {
                // Redirect the user
                window.location.href = "https://codeflarelimited.com/catalogue";
                });
          }else{
            Swal.fire({
                title: 'Error!',
                text: 'An error occurred',
                icon: 'error',
                confirmButtonText: 'OK'
              });
          }
        })
        .catch(function (err) {
            //handle error
            Swal.fire({
                title: 'Error!',
                text: err,
                icon: 'error',
                confirmButtonText: 'OK'
              })
        });
    }
    }
    

    render(){
        return(
            <div className="subscribe">
    <div>
    <h1>Receive Daily Insights</h1>
    <p>Subscribe to our newsletter</p>
    </div>
    <div>
    <form>
    <div>
      <div className="form-btn">
      <input type="text" placeholder="Email Address" value={this.state.email_}
        onChange={e => this.setState({ email_: e.target.value })} />
        <button className="text-capitalize" type="submit" onClick={e => this.handleSubscribe(e)}>
            Subscribe
            </button>
        </div>
    </div>
        </form>
        </div>
        </div>
        )
    }
}

export default Subscribe;